"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toOperationExtraRaw = exports.fromOperationExtraRaw = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
function fromOperationExtraRaw(extra) {
    if (!extra)
        return extra;
    const { gasLimit, gasPremium, gasFeeCap } = extra;
    if (gasLimit !== undefined)
        extra = Object.assign(Object.assign({}, extra), { gasLimit: new bignumber_js_1.default(gasLimit) });
    if (gasPremium !== undefined)
        extra = Object.assign(Object.assign({}, extra), { gasPremium: new bignumber_js_1.default(gasPremium) });
    if (gasFeeCap !== undefined)
        extra = Object.assign(Object.assign({}, extra), { gasFeeCap: new bignumber_js_1.default(gasFeeCap) });
    return extra;
}
exports.fromOperationExtraRaw = fromOperationExtraRaw;
function toOperationExtraRaw(extra) {
    if (!extra)
        return extra;
    const { gasLimit, gasPremium, gasFeeCap } = extra;
    if (gasLimit !== undefined)
        extra = Object.assign(Object.assign({}, extra), { gasLimit: gasLimit.toNumber() });
    if (gasPremium !== undefined)
        extra = Object.assign(Object.assign({}, extra), { gasPremium: gasPremium.toFixed() });
    if (gasFeeCap !== undefined)
        extra = Object.assign(Object.assign({}, extra), { gasFeeCap: gasFeeCap.toFixed() });
    return extra;
}
exports.toOperationExtraRaw = toOperationExtraRaw;
exports.default = {
    fromOperationExtraRaw,
    toOperationExtraRaw,
};
//# sourceMappingURL=account.js.map